import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const cookieSections = [
  ["What cookies are", "Cookies and similar browser storage are small records that help a website remember information between page views or visits."],
  ["Strictly necessary storage", "We use local browser storage to keep your shopping bag and wishlist available. This storage is necessary for features you request and does not track you across unrelated websites."],
  ["Analytics and advertising", "We do not currently use advertising cookies or third-party behavioral tracking. If this changes, this policy and any required consent controls will be updated before optional technologies are activated."],
  ["Your controls", "You can clear or block cookies and local storage in your browser settings. Blocking necessary storage may prevent the bag and wishlist from remembering your selections."],
  ["Policy changes", "We may revise this notice as the storefront changes. The date at the top identifies the latest version."],
];

function Cookies() {
  return (
    <main className="legal-page privacy-page">
      <header><p className="eyebrow">LEGAL</p><h1>Cookie policy</h1><p>Last updated September 16, 2026</p></header>
      <div className="legal-layout">
        <aside><span>On this page</span>{cookieSections.map(([title], index) => <a href={`#cookies-${index + 1}`} key={title}>{String(index + 1).padStart(2, "0")} {title}</a>)}</aside>
        <article>
          <p className="legal-intro">This notice explains how {siteConfig.brandName} uses browser storage on {siteConfig.website}.</p>
          {cookieSections.map(([title, copy], index) => <section id={`cookies-${index + 1}`} key={title}><span>{String(index + 1).padStart(2, "0")}</span><h2>{title}</h2><p>{copy}</p></section>)}
          <section><h2>Questions</h2><p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> if you have a question about this policy.</p></section>
        </article>
      </div>
    </main>
  );
}

export default Cookies;
